import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-consultant-card-skeleton',
  imports: [Skeleton],
  templateUrl: './dashboard-consultant-card-skeleton.html',
})
export class DashboardConsultantCardSkeleton {}
